<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择仓位"
      width="800px"
      class="adaptationModal"
  >
    <table class="normalTable" border="1" cellspacing="0">
      <tr>
        <td v-for="item in columns">{{item}}</td>
        <td>操作</td>
      </tr>
      <tr v-for="item in dataSource">
        <td v-for="i in item">{{i.name}}</td>
        <td>
          <el-button type="primary" size="mini" @click="checkHandle(item)">选择</el-button>
        </td>
      </tr>
    </table>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        columns: [],
        dataSource: [],
      };
    },

    methods: {
      open(warehouseNo) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getLocations(warehouseNo);
        });
      },

      // 根据仓库获取仓位
      getLocations(warehouseNo) {
        this.$http.get("basic", `warehouseLocations/kingdee?warehouseNo=${warehouseNo}`).then((res) => {
          if (res.success) {
            this.columns = res.data.flexName;
            this.dataSource = res.data.data;
          }
        });
      },

      // 选择
      checkHandle(item) {
        let params = {
          locationNo: "",
          locationName: "",
        };
        if (item.length === 1) {
          params.locationNo = item[0].number;
          params.locationName = item[0].name;
        } else {
          let temp = [];
          let temp1 = [];
          item.forEach((i) => {
            temp.push(i.number);
            temp1.push(i.name);
          });
          params.locationNo = temp.join();
          params.locationName = temp1.join();
        }
        this.dialogVisible = false;
        this.$emit("select", params);
      },
    },
  };
</script>

<style lang="scss" scoped>
.normalTable {
  width: 100%;
  border-color: #e8eaec;
  tr {
    td {
      padding: 8px;
      &:last-child {
        width: 80px;
        text-align: center;
      }
    }
    &:first-child {
      font-weight: 700;
      background-color: #f8f8f9;
    }
  }
}
</style>
